/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Schedule } from '../../models/schedule';
import { ScheduleEntity } from '../../models/schedule-entity';

export interface CreateSchedule$Params {
  location_id: string;
  
    /**
     * Schedule
     */
    body: Schedule
}

export function createSchedule(http: HttpClient, rootUrl: string, params: CreateSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleEntity>> {
  const rb = new RequestBuilder(rootUrl, createSchedule.PATH, 'post');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduleEntity>;
    })
  );
}

createSchedule.PATH = '/locations/{location_id}/schedules';
